import { Container, Graphics, Text } from 'pixi.js';

export function addFPSCounter(): void {
  const root = new Container();

  const graphics = new Graphics().props({
    parent: root,
  });
  graphics.rect(-200, 0, 200, 80);
  graphics.fill({ color: 'black' });

  const text = new Text({
    text: '--',
    style: {
      fontSize: 50,
      fill: 'white',
    }
  }).props({
    parent: root,
    anchor: 0.5,
    x: -100,
    y: 40,
  });

  root.pixi.ticker.add(() => {
    root.props({
      parent: root.pixi.stage,
      x: root.pixi.renderer.width,
    });
  });

  setInterval(() => {
    text.text = root.pixi.ticker.FPS.toFixed(2);
  }, 200);
}
